import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AuditLogsListPage } from '@/pages/admin/audit-logs/AuditLogsListPage';

const auditLogsSearchSchema = z.object({
  // Page-owned params
  tenantId: z.string().optional(),
  page: z.coerce.number().int().positive().optional(),
  limit: z.coerce.number().int().positive().optional(),

  // DataTable chip filter params (namespaced with tableId="auditLogs")
  auditLogs_action_filter: z.string().optional(),
  auditLogs_entityType_filter: z.string().optional(),
  auditLogs_actorId_filter: z.string().optional(),
  auditLogs_entityId_filter: z.string().optional(),
  // dateRange is JSON-encoded {from?, to?}
  auditLogs_timestamp_filter: z.string().optional(),

  // DataTable namespaced state params (tableId="auditLogs")
  auditLogs_sort: z.string().optional(),
  auditLogs_page: z.coerce.number().int().positive().optional(),
  auditLogs_pageSize: z.coerce.number().int().positive().optional(),
  auditLogs_hiddenColumns: z.string().optional(),
  auditLogs_q: z.string().optional()
});

export const Route = createFileRoute('/admin/audit-logs/')({
  component: AuditLogsListPage,
  validateSearch: auditLogsSearchSchema
});
